import * as React from 'react';
import {useState} from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import {
  Box, Alert,
  Snackbar,
} from '@mui/material';
import OnlineRegister from './OnlineRegister';
import UpiRegister from './UpiRegister';
// import VanRegister from './VanRegsiter';
import CdmRegister from './CDM_Register';
import CashDeposit from './CashDeposit';
import RegisteredAccounts from './RegisteredAccounts';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

function TabPanel(props) {
  const { children, value, index, ...other } = props;



  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export default function FullWidthTabs() {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [AlerType, setAlertType] = useState('success')
  const [AlertMessage, setAlertMessage] = useState(null)
  const [ErrOpen, setErrOpen] = useState(false)
  const [openLoader, setOpenLoader] = useState(false)

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const handleErrClose = () => {
    setErrOpen(false)
   
  }

  return (
    <Box sx={{ bgcolor: 'background.paper', width: '100%' }}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 3 }}
        open={openLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={ErrOpen} autoHideDuration={5000} onClose={handleErrClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleErrClose} variant='filled' severity={AlerType} sx={{ width: '100%' }}>
          {AlertMessage}
        </Alert>
      </Snackbar>
      <AppBar position="static" sx={{ bgcolor: '#EDE7F6', borderRadius: '10px' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="secondary"
          variant='fullWidth'
          aria-label="full width tabs example"
        >
          <Tab label="Online" {...a11yProps(0)} />
          <Tab label={
            <div>
              <Typography>Cash Deposit</Typography>
              <Typography style={{ fontSize: '0.8em', lineHeight: '1' }}>(Bank Branch)</Typography>
            </div>
          } {...a11yProps(1)} />
          <Tab label={
            <div>
              <Typography>UPI</Typography>
              <Typography style={{ fontSize: '0.8em', lineHeight: '1' }}>(Unique Payment Interface)</Typography>
            </div>
          }
            // {...a11yProps(2)} />
            //   <Tab label={
            //   <div>
            //     <Typography>VAN</Typography>
            //     <Typography style={{ fontSize: '0.8em', lineHeight: '1' }}>(Virtual Account Number)</Typography>
            //   </div>
            // } 
            {...a11yProps(2)} />
          <Tab label={
            <div>
              <Typography>CDM</Typography>
              <Typography style={{ fontSize: '0.8em', lineHeight: '1' }}>(Cash Deposit Machine)</Typography>
            </div>
          } {...a11yProps(3)} />

          <Tab label={
            <div>
              <Typography>Registered accounts</Typography>
            </div>
          } {...a11yProps(4)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0}>
          <OnlineRegister />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <CashDeposit setAlertType={setAlertType} setAlertMessage={setAlertMessage} setErrOpen={setErrOpen} setOpenLoader={setOpenLoader}/>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <UpiRegister />
        </TabPanel>
        {/* <TabPanel value={value} index={3}>
        <VanRegister/>
      </TabPanel> */}
        <TabPanel value={value} index={3}>
          <CdmRegister setAlertType={setAlertType} setAlertMessage={setAlertMessage} setErrOpen={setErrOpen} setOpenLoader={setOpenLoader}/>
        </TabPanel>
        <TabPanel value={value} index={4}>
          <RegisteredAccounts />
        </TabPanel>
        <TabPanel value={value} index={5}>
          Item Seven
        </TabPanel>
      </SwipeableViews>
    </Box>
  );
}
